import { P2GBox, P2GDate, SvgConfirmCircle, P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { BookingDetails } from '~/lib/api/smartsend/types';
import { GetRefundsForOrderLineId, RefundRecord } from '../../../lib/cache/ExtendedOrderCache';
import AlertWithIcon from '../../AlertWithIcon';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { SettingsCache } from '~/lib/consts/settings-cache';

interface props {
  bookingDetails: BookingDetails;
}

const Refund = ({ r, currencyCode }: { r: RefundRecord; currencyCode?: string }) => {
  const date = useMemo(() => {
    if (!r.created) {
      return null;
    }
    const d = r.created instanceof Date ? r.created : new Date(r.created);
    return isNaN(d.getTime()) ? null : d;
  }, [r.created]);

  return (
    <AlertWithIcon
      icon={<SvgConfirmCircle />}
      iconSrc="/theme/icons/ConfirmCircle.svg"
      color="success"
      key={r.orderlineId}
    >
      <P2GText component="p">
        <strong>{r.status}</strong>
      </P2GText>
      {date && (
        <P2GText component="p" small>
          <i>
            Created <P2GDate small date={date} size="medium" /> for {toDisplayCurrency(currencyCode, r.amount)}
          </i>
        </P2GText>
      )}
    </AlertWithIcon>
  );
};

export default function ItemRefunds(props: props) {
  const refunds = useMemo(() => GetRefundsForOrderLineId(props.bookingDetails?.OrderLineId), [props.bookingDetails]);

  if (!props.bookingDetails || !props.bookingDetails?.OrderLineId || refunds.length === 0) {
    return null;
  }

  return (
    <P2GBox>
      {refunds.map((r) => (
        <Refund
          key={r.orderlineId}
          r={r}
          currencyCode={props.bookingDetails.FinancialSummary?.CurrencyCode ?? SettingsCache.currencyCode}
        />
      ))}
    </P2GBox>
  );
}
